import { CALL_API } from 'redux-api-middleware'
import {
  BASE_URL,
  MASTER_DATA_GET_REQUEST,
  MASTER_DATA_GET_SUCCESS,
  MASTER_DATA_GET_FAILURE,
} from '../../constants'

export function getMasterData(access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/master-datas`,
      method: 'GET',
      types: [
        MASTER_DATA_GET_REQUEST,
        MASTER_DATA_GET_SUCCESS,
        MASTER_DATA_GET_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}



// WEBPACK FOOTER //
// ./src/actions/master-data/master-data-action.js